import styles from './style.module.css'

interface Props {
  children: React.ReactNode
  label: string
}

export const InputWrapper = ({children, label}: Props) => {
  return (
    <div className={styles.input_wrapper}>
      <label className={styles.label}>{label}</label>
      {children}
    </div>
  )
}

export default InputWrapper;
